// True when the browser received a page from scripts/prerender.mjs rather
// than the empty SPA shell. Read at import time, before React mounts and
// replaces the root's children. The pre-render itself boots from the empty
// shell, so snapshots never capture this as true.
export const wasPrerendered = (document.getElementById('root')?.childElementCount ?? 0) > 0;
